/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const deleteChallengeClipResponseSchema = createApiResponseSchema(
  z.undefined(),
) as z.ZodSchema<IAPI<undefined>>;

export type IDeleteChallengeClipResponse = IAPI<undefined>;
